document.addEventListener("DOMContentLoaded", function () {
  // 폼 필드 참조
  const firstNameInput = document.getElementById("first-name");
  const lastNameInput = document.getElementById("last-name");
  const emailInput = document.getElementById("email");
  const messageTextarea = document.getElementById("textarea");
  const submitButton = document.getElementById("submitButton");
  const countrySelect = document.getElementById("AddressCountryNew");
  const stateSelect = document.getElementById("AddressProvinceNew");

  // 페이지 로드시 입력 필드가 비어 있으면 자동으로 'c-input--active' 또는 'c-textarea--active' 클래스를 추가
  toggleActiveClass(firstNameInput);
  toggleActiveClass(lastNameInput);
  toggleActiveClass(emailInput);
  toggleActiveClass(messageTextarea);

  // 유효성 검사 메시지 요소
  const firstNameAlert = firstNameInput
    .closest(".c-input")
    .querySelector(".c-input__alert");
  const lastNameAlert = lastNameInput
    .closest(".c-input")
    .querySelector(".c-input__alert");
  const emailAlert = emailInput
    .closest(".c-input")
    .querySelector(".c-input__alert");
  const messageAlert = messageTextarea
    .closest(".c-textarea")
    .querySelector(".c-textarea__alert");
  const countryAlert = countrySelect
    .closest(".c-select")
    .querySelector(".c-select__alert");
  const stateAlert = stateSelect
    .closest(".c-select")
    .querySelector(".c-select__alert");

  // 유효성 검사 함수
  function validateForm() {
    let isValid = true;

    // 이름 검증
    if (!firstNameInput.value.trim()) {
      firstNameAlert.style.display = "block";
      isValid = false;
    } else {
      firstNameAlert.style.display = "none";
    }

    if (!lastNameInput.value.trim()) {
      lastNameAlert.style.display = "block";
      isValid = false;
    } else {
      lastNameAlert.style.display = "none";
    }

    if (!emailInput.value.trim()) {
      emailAlert.style.display = "block";
      isValid = false;
    } else {
      emailAlert.style.display = "none";
    }

    // 메시지 검증
    if (!messageTextarea.value.trim()) {
      messageAlert.style.display = "block";
      isValid = false;
    } else {
      messageAlert.style.display = "none";
    }

    // Country 검증 (첫 번째 옵션이 선택되었거나 선택되지 않았을 경우)
    if (!countrySelect.value || countrySelect.value === "0") {
      countryAlert.style.display = "block";
      isValid = false;
    } else {
      countryAlert.style.display = "none";
    }

    // State 검증 (첫 번째 옵션이 선택되었거나 선택되지 않았을 경우)
    if (!stateSelect.value || stateSelect.value === "0") {
      stateAlert.style.display = "block";
      isValid = false;
    } else {
      stateAlert.style.display = "none";
    }

    return isValid;
  }

  // 이메일 유효성 검사 함수
  function validateEmail() {
    const emailValue = emailInput.value.trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailValue === "") {
      emailAlert.style.display = "block";
      emailAlert.textContent = "Please enter your email.";
      return false;
    } else if (!emailPattern.test(emailValue)) {
      emailAlert.style.display = "block";
      emailAlert.textContent = "Please provide a valid email address.";
      return false;
    } else {
      emailAlert.style.display = "none";
      return true;
    }
  }

  // 제출 버튼 클릭 시
  document
    .getElementById("validateButton")
    .addEventListener("click", function () {
      if (validateForm()) {
        // 모든 필드가 유효하면 실제 제출 버튼을 클릭
        submitButton.click();
      }
    });

  // 문자 수 카운트
  messageTextarea.addEventListener("input", function () {
    const maxLength = 3900;
    const currentLength = messageTextarea.value.length;
    const countDisplay = messageTextarea
      .closest(".info-request__line")
      .querySelector(".c-textarea__count em");
    countDisplay.textContent = currentLength;

    if (currentLength > maxLength) {
      messageTextarea.value = messageTextarea.value.slice(0, maxLength);
    }
  });

  firstNameInput.addEventListener("input", function () {
    if (firstNameInput.value.trim() !== "") {
      firstNameAlert.style.display = "none";
    }
    toggleActiveClass(firstNameInput);
  });

  lastNameInput.addEventListener("input", function () {
    if (lastNameInput.value.trim() !== "") {
      lastNameAlert.style.display = "none";
    }
    toggleActiveClass(lastNameInput);
  });

  emailInput.addEventListener("input", function () {
    validateEmail(); // 이메일 유효성 검사
    toggleActiveClass(emailInput);
  });

  messageTextarea.addEventListener("input", function () {
    if (messageTextarea.value.trim() !== "") {
      messageAlert.style.display = "none";
    }
    toggleActiveClass(messageTextarea);
  });

  countrySelect.addEventListener("change", function () {
    if (countrySelect.value !== "0") {
      countryAlert.style.display = "none";
      stateAlert.style.display = "none";
    }
    toggleActiveClass(countrySelect);
  });

  stateSelect.addEventListener("change", function () {
    if (stateSelect.value !== "0") {
      stateAlert.style.display = "none";
    }
    toggleActiveClass(stateSelect);
  });

  // 입력값이 있으면 부모 div에 'c-input--active' 클래스 추가
  function toggleActiveClass(element) {
    const parentFieldInput = element.closest(".c-input");
    const parentFieldTextArea = element.closest(".c-textarea");
    if (
      element.tagName === "TEXTAREA" ||
      element.tagName === "INPUT" ||
      element.tagName === "SELECT"
    ) {
      if (element.value.trim() !== "" || element.checked) {
        if (element.tagName === "TEXTAREA") {
          parentFieldTextArea.classList.add("c-textarea--active");
        } else {
          parentFieldInput.classList.add("c-input--active");
        }
      } else {
        if (element.tagName === "TEXTAREA") {
          parentFieldTextArea.classList.remove("c-textarea--active");
        } else {
          parentFieldInput.classList.remove("c-input--active");
        }
      }
    }
  }
});
